<template>
  <form-panel
    title="Crear lista de clientes"
    width="large"
    @closePanel="onCloseModal">
    <el-form
      v-loading.fullscreen.lock="fullscreenLoading"
      ref="formList"
      :model="model"
      :rules="rules"
      label-position="top"
      class="form-list padding-20"
      @submit.native.prevent="onSubmit">
      <el-form-item
        label="Nombre de la lista"
        prop="name">
        <el-input v-model.trim="model.name"/>
      </el-form-item>
      <el-form-item
        label="Descripción"
        prop="description">
        <el-input
          v-model.trim="model.description"
          :rows="4"
          type="textarea"/>
      </el-form-item>
      <el-form-item label="Selecciona un filtro a aplicar.">
        <el-checkbox
          v-model="isChecked"
          @change="onChange()">Sin filtro</el-checkbox>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item>
            <el-select
              v-model="filter.modelActivities"
              placeholder="Selecciona una actividad"
              filterable
              @change="selectActivities">
              <el-option
                v-for="item in filter.activities"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-select
              v-model="filter.modelSurface"
              placeholder="Selecciona una superficie"
              @change="selectSurface">
              <el-option
                v-for="item in filter.surface"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        label="Selecciona tus clientes"
        prop="rules">
        <el-transfer
          v-model="model.rules"
          :data="filter.customer"
          :titles="['Cliente','Lista de Clientes']"
          :button-texts="['Eliminar', 'Agregar']"
          class="transfer__margin"
          filterable/>
      </el-form-item>
      <el-row
        type="flex"
        justify="end">
        <el-col :span="12">
          <el-button
            type="primary"
            native-type="submit">Aceptar</el-button>
        </el-col>
      </el-row>
    </el-form>
  </form-panel>
</template>

<script>
import FormPanel from '@/components/_shared/form-panel'
import CustomerListModel from '@/models/campaigns/campaign-list-customer-model'
import http from '@/services/http.service'
export default {
  name: 'CampaignCreateListModal',
  components: {
    FormPanel
  },
  data () {
    return {
      model: CustomerListModel.model(),
      rules: CustomerListModel.rules(),
      fullscreenLoading: false,
      filter: {
        customer: [],
        surface: [
          {
            name: '0 a 10 hectáreas',
            id: 1
          },
          {
            name: '11 a 50 hectáreas',
            id: 2
          },
          {
            name: '51 a 100 hectáreas',
            id: 3
          },
          {
            name: 'más 100 hectáreas',
            id: 4
          }
        ],
        activities: [],
        todo: [],
        checkModel: null,
        modelActivities: [],
        modelSurface: null,
        selectActivities: true,
        selectSurface: false,
        customerActivities: []
      },
      arrayActivities: [],
      arraySurface: [],
      isChecked: false
    }
  },
  mounted () {
    this.fullscreenLoading = true
    let _promises = []
    _promises.push(this.$store.dispatch('customers/query', {
      'filters[whereNot][email][eq]': '',
      limit: 1000000,
      sort: 'email ASC'}))
    _promises.push(this.$store.dispatch('activities/query', {'filters[where][type][eq]': 'product', limit: 1000}))

    Promise.all(_promises)
      .then((data) => {
        let _customer = data[0].data.items
        _customer.forEach((item) => {
          if (item.email) {
            this.filter.customer.push({
              label: item.email,
              key: item.id
            })
          }
        })
        this.filter.todo = this.filter.customer
        this.filter.activities = data[1].data.items // activities
      }).catch(e => {
        this.$notify.error({
          message: 'Por favor, vuelve a intentarlo.'
        })
      }).finally(() => {
        this.fullscreenLoading = false
      })
  },
  methods: {
    onChange () {
      this.fullscreenLoading = true
      if (this.isChecked) {
        this.filter.modelSurface = null
        this.filter.customer = []
        this.filter.customer = this.filter.todo
        this.filter.modelActivities = []
        this.arrayActivities = []
        this.arraySurface = []
      }
      this.fullscreenLoading = false
    },
    selectSurface () {
      this.fullscreenLoading = true
      this.isChecked = false
      let params
      if (this.filter.modelSurface === 1) {
        params = 'filters[whereBetween][surface][]=0.0&filters[whereBetween][surface][]=10.0&limit=1000'
      } else if (this.filter.modelSurface === 2) {
        params = 'filters[whereBetween][surface][]=11.0&filters[whereBetween][surface][]=50.0&limit=1000'
      } else if (this.filter.modelSurface === 3) {
        params = 'filters[whereBetween][surface][]=51.0&filters[whereBetween][surface][]=100.0&limit=1000'
      } else if (this.filter.modelSurface === 4) {
        params = 'filters[whereBetween][surface][]=101.0&filters[whereBetween][surface][]=100000.0&limit=1000'
      }

      http.get(`${process.env.API_URL}activity-surface/customers?${params}`)
        .then(({data}) => {
          this.filter.customer = []
          data.items.forEach((item) => {
            this.filter.customer.push({
              label: item.email,
              key: parseInt(item.id)
            })
          })
          this.arraySurface = this.filter.customer
          this.filterTODO()
        })
        .finally(() => {
          this.fullscreenLoading = false
        })
    },
    selectActivities () {
      this.fullscreenLoading = true
      this.isChecked = false
      this.filter.customerActivities = []
      this.$store.dispatch('customerActivities/query', {
        'filters[where][activityId][eq]': this.filter.modelActivities,
        with: 'customers',
        limit: 1000
      })
        .then(({data}) => {
          this.filter.customerActivities = data.items
          this.filterCustomerActivities()
        })
        .finally(() => {
          this.fullscreenLoading = false
        })
    },
    filterCustomerActivities () {
      this.filter.customer = []
      if (this.filter.customerActivities.length > 0) {
        for (let _i = 0; _i < this.filter.todo.length; _i++) {
          for (let _a = 0; _a < this.filter.customerActivities.length; _a++) {
            if (this.filter.todo[_i].label === this.filter.customerActivities[_a].customers.email) {
              this.filter.customer.push({
                label: this.filter.todo[_i].label,
                key: parseInt(this.filter.todo[_i].key)
              })
            }
          }
        }
        this.arrayActivities = this.filter.customer
        this.filterTODO()
      } else {
        this.$message({
          message: 'No hay clientes para la actividad selecciona.',
          type: 'warning'
        })
      }
    },
    filterTODO () {
      if (this.arrayActivities.length > 0 && this.arraySurface.length < 0) {
        this.filter.customer = this.arrayActivities
      } else if (this.arrayActivities.length < 0 && this.arraySurface.length > 0) {
        this.filter.customer = this.arraySurface
      } else if (this.arrayActivities.length > 0 && this.arraySurface.length > 0) {
        this.filter.customer = []
        for (let i = 0; i < this.arrayActivities.length; i++) {
          for (let a = 0; a < this.arraySurface.length; a++) {
            if (this.arrayActivities[i].label === this.arraySurface[a].label) {
              this.filter.customer.push({
                label: this.arraySurface[a].label,
                key: this.arraySurface[a].key
              })
              continue
            }
          }
        }
      }
    },
    onCloseModal () {
      this.$store.dispatch('app/toggleCampaignListPanel')
    },
    onSubmit () {
      this.$refs['formList'].validate((valid) => {
        this.fullscreenLoading = true
        this.model.activities.push(this.filter.modelActivities)
        this.model.type = this.filter.checkModel
        if (valid) {
          this.$store.dispatch('customerGroups/save', this.model)
            .then(({ data }) => {
              this.$message.success('La lista se creo con exito')
            })
            .catch(e => {
              this.$message.error('La lista no pudo ser creada, vuelva a intentarlo')
            })
            .finally(() => {
              this.$store.dispatch('app/toggleCampaignListPanel')
              this.fullscreenLoading = false
              this.$emit('nameGroup', this.model.name)
            })
        } else {
          this.fullscreenLoading = false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .form-list{
    .el-select{
      width: 100%;
    }
    .transfer__margin {
      margin: 30px 0px 30px 80px;
    }
    .el-button {
      background-color: $primary;
      color: #ffffff;
      width: 100%;
      box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/campaign-create-list-modal.vue